import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

export const usePaginationDisplayText = ({ countUnknown = false }: { countUnknown?: boolean }) => {
  const { t } = useTranslation()

  return useCallback(
    ({ from, to, count }: { from: number; to: number; count: number }) => {
      return countUnknown
        ? t('global.pagination.of_more_than', { from, to })
        : t('global.pagination.of', { from, to, count })
    },
    [countUnknown, t],
  )
}
